import _ from "lodash";
import { AREA } from '../actions/types';
import { constants } from '../Constants/constants';

const INITIAL_STATE = {
    ui: {
        area: _.cloneDeep(constants.AREA_INPUT)
    }
}

const areaReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case AREA.SET_AREA_DEFAULT:
            return Object.assign({}, INITIAL_STATE)
        case AREA.SET_AREA:
        case AREA.SET_AREA_VALUE:
            return Object.assign({}, {
                ...state,
                ui: {
                    ...state.ui,
                    area: action.area
                }
            })
        default:
            return state
    }
}

export default areaReducer